import multiMonthPlugin from "@fullcalendar/multimonth";
import React, { useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { Modal, ModalBody } from "reactstrap";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import { getCalender } from "../../../../redux/calender/action";
import ModelTaskDetails from "../ModelTaskDetails";
import ModalMilestoneDetails from "../ModalMilestoneDetails";
import CalendarModel from "../CalenderModel";
import ContestDetailModal from "../ContestDetailModal";
import { addOneDayToDate, formatDate } from "../../../../assests/extention/commonfunction";

export default function Calendar({ id, action }) {
  const [modal, setModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [date, setDate] = useState({
    start_date: "",
    end_date: "",
  });
  const [events, setEvents] = useState([]);

  const dispatch = useDispatch();
  const calender = useSelector(
    ({ calender: { calenderdetails } }) => calenderdetails
  );

  const convertEventsToApiResponse = (holidays, milestones, task, contest) => {

    const formattedHolidays = holidays.map((event) => ({
      ...event,
      id: event?.id,
      model_id: event?.id,
      model_title: event?.title,
      title: event.title,
      start: formatDate(event?.start_date),
      end: addOneDayToDate(event?.end_date),
      color: "red",
      type: "Holiday",
      textColor: "white",
      event_type: 1,
    }));

    const formattedMilestones = milestones.map((event) => ({
      ...event,
      id: event?.id,
      model_id: event?.id,
      model_title: event?.title,
      title: event.post_title,
      start: formatDate(event?.ends_on),
      end: formatDate(event?.ends_on),
      color: "#dfd2c7",
      type: "Milestone",
      event_type: 2,
    }));

    const formattedTasks = task.map((event) => ({
      ...event,
      id: event?.id,
      model_id: event?.id,
      model_title: event?.title,
      title: event.title,
      description: event.description,
      start: formatDate(event?.due_date),
      end: formatDate(event?.due_date),
      color: "#ef7710",
      type: "Task",
      event_type: 3,
    }));

    const formattedContests = contest.map((contest) => ({
      ...contest,
      id: contest?.id,
      model_id: contest?.id,
      model_title: contest?.title,
      title: contest.title,
      description: contest.description,
      start: formatDate(contest?.last_date),
      end: formatDate(contest?.last_date),
      color: "#cee1ff",
      type: "Contest",
      event_type: 4,
    }));

    return [
      ...formattedHolidays,
      ...formattedMilestones,
      ...formattedTasks,
      ...formattedContests,
    ];
  };

  useEffect(() => {
    if (date?.start_date && date?.end_date) {
      dispatch(getCalender(date?.start_date, date?.end_date, id));
    }
  }, [date?.start_date, date?.end_date, dispatch]);

  useEffect(() => {
    if (calender?.task && calender?.milestones && calender?.holidays) {
      const apiResponse = convertEventsToApiResponse(
        calender.holidays,
        calender.milestones,
        calender.task,
        calender.contests
      );
      setEvents(apiResponse);
    }
  }, [calender]);

  const toggle = () => setModal(!modal);

  const handleEventClick = (clickInfo) => {
    setSelectedEvent(clickInfo.event);
    toggle();
  };
  const handleDatesSet = (arg) => {
    const startDate = new Date(arg?.startStr).toISOString().split("T")[0];
    const endDate = new Date(arg?.endStr).toISOString().split("T")[0];
    setDate({
      start_date: startDate || "",
      end_date: endDate || "",
    });
  };


  const apihit = () => {
    dispatch(getCalender(date?.start_date, date?.end_date, id));
  }

  useEffect(() => {
    if (action && date?.start_date && date?.end_date) {
      dispatch(getCalender(date?.start_date, date?.end_date, id));
    }
  }, [action])
  return (
    <div style={{ height: "100%" }}>
      <FullCalendar
        plugins={[multiMonthPlugin, dayGridPlugin]}
        initialView="multiMonth"
        views={{
          multiMonth: {
            type: "multiMonth",
            duration: { months: 12 },
          },
        }}
        eventClick={handleEventClick}
        events={events}
        displayEventEnd={true}
        datesSet={handleDatesSet}
        headerToolbar={{
          left: "prev",
          center: "title",
          right: "next",
        }}
      />

      <Modal isOpen={modal} toggle={toggle} className="popupmodal yes-no">
        {selectedEvent?.extendedProps.event_type == 1 ? (
          <CalendarModel
            date={date}
            setModel={setModal}
            data={selectedEvent?.extendedProps}
            apihit={apihit}
          />
        ) : (
          <>
            <button className="btn close-button" onClick={toggle}>
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
              />
            </button>
            <ModalBody>
              <h4>
                {selectedEvent?.extendedProps.event_type == 1
                  ? "Holiday"
                  : selectedEvent?.extendedProps.event_type == 2
                    ? "Milestone"
                    : selectedEvent?.extendedProps.event_type == 3
                      ? "Task"
                      : selectedEvent?.extendedProps.event_type == 4
                        ? "Contest"
                        : ""}
                : {selectedEvent ? selectedEvent?.title : ""}
              </h4>
              {selectedEvent?.extendedProps.event_type == 1 ? (
                <CalendarModel
                  setModel={setModal}
                  data={selectedEvent?.extendedProps}
                />
              ) : selectedEvent?.extendedProps.event_type == 2 ? (
                <ModalMilestoneDetails data={selectedEvent?.extendedProps} />
              ) : selectedEvent?.extendedProps.event_type == 3 ? (
                <ModelTaskDetails data={selectedEvent?.extendedProps} />
              ) : selectedEvent?.extendedProps.event_type == 4 ? (
                <ContestDetailModal data={selectedEvent?.extendedProps} />
              ) : (
                ""
              )}
            </ModalBody>
          </>
        )}
      </Modal>
    </div>
  );
}
